import {useEffect, useState} from 'react';

/** A transient navigation hint, never proof of payment or an allowance grant. */
export function useRadarBillingReturn(workspaceId: string | undefined) {
  const [returnWorkspace, setReturnWorkspace] = useState<string | null>(null);
  useEffect(() => {
    if (!workspaceId) { setReturnWorkspace(null); return; }
    const url = new URL(window.location.href);
    if (url.searchParams.get('billing') === 'return') {
      setReturnWorkspace(workspaceId);
      url.searchParams.delete('billing');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } else {
      // Keep the captured hint through Strict Mode's repeated effect setup, but
      // do not carry it into another workspace after client-side navigation.
      setReturnWorkspace(previous => previous === workspaceId ? previous : null);
    }
  }, [workspaceId]);
  return {
    returning: !!workspaceId && returnWorkspace === workspaceId,
    onReturnDismissed: () => setReturnWorkspace(null),
  };
}
